import { REFERRAL_REQUEST, CHANGE_REFERRAL_DATA } from 'actions/auth/constants';

/**
 * Create a referral request action.
 * Called from react component
 * @param {string} referral
 * @returns {{type: *, payload: {referral: *}}}
 */
export function referralRequest(referral) {
  return { type: REFERRAL_REQUEST, payload: { referral } };
}

/**
 * Create a change referral action.
 * Called after new data from server is fetched. Example: from the saga
 * @param {object} referral referal data from server
 * @returns {{type: *}}
 */
export function changeReferralData(referral) {
  return { type: CHANGE_REFERRAL_DATA, payload: { referral } };
}
